export default {
  courses: [],
  course: {}
}
